<template>
    <div class="field textarea">
        <label class="field__label">{{ label }}</label>

        <textarea class="field__input" :placeholder="placeholder" rows="6" ref="field" required></textarea>
    </div>
</template>

<script>
export default {
    name: "TextareaField",
    props: {
        label: String,
        placeholder: String
    },
    methods: {
        getValue() {
            return this.$refs.field.value;
        }
    }
}
</script>

<style scoped lang="stylus">
.textarea {
    &__input {
        resize vertical;
    }
}
</style>